<template>
<vs-popup :active.sync="isProductVariantSelectionOpen" title="Ürün Varyant Seçimi" id="variant-first-selection">
    <vs-row vs-type="flex" vs-w="12" class="bg-primary">
      <vs-col vs-type="flex" vs-w="12" vs-justify="space-between" class="mx-5 py-4">
        <vs-button v-if="(currentVariants != null && variantDataSet.length!=0)" radius icon-pack="feather" icon="icon-arrow-left" color="tranparent"
                   class="bg-secondary text-primary" @click="backVariantSelection"></vs-button>
        <vs-button radius icon-pack="feather" icon="icon-x" color="tranparent" class="bg-secondary text-primary ml-auto"
                   @click="closeVariantSelection"></vs-button>
      </vs-col>
    </vs-row>
    <vs-row vs-type="flex" vs-w="12" vs-justify="center" class="p-5">
      <vs-col vs-type="flex" class="w-auto mx-5 my-3" v-for="(variant) in currentVariants" :key="variant.id">
        <vs-button class="half-friendly-border sale-box-shadow bold"
                   :class="{'text-white bg-primary' : variant.isDefault == true, 'bg-secondary text-primary' : variant.isDefault == false  }"
                   @click="variantSelection(variant)" size="large" color="transparent">{{variant.name}}
          {{variant.price==null?"":(" - "+variant.price +" ₺")}}
        </vs-button>
      </vs-col>
    </vs-row>
  </vs-popup>
</template>

<script>
  import ProductTypes from "@/model/constants/ProductTypes";

  export default {
    components: {},
    data() {
      return {
        isProductVariantSelectionOpen : false,
        currentVariants: null,
        variantDataSet: []
      };
    },
    computed: {
      preSelectedProduct() {
        return this.$store.getters["selfservice/getPreSelectedProduct"];
      }
    },
    props: {
      isOpen: {
        type: Boolean,
        required: false
      }
    },
    watch: {
      isProductVariantSelectionOpen: function (val) {
        if (!val) {
          this.variantDataSet = [];
          this.$store.dispatch("selfservice/setPreSelectedProduct", null);
        }
      },
      isOpen: function(val) {
      },
      preSelectedProduct: function(val) {
        if (val != null)
          this.currentVariants = this.preSelectedProduct.children;
        else
          this.currentVariants = null;
      },
      product: function(val) {
        this.selectedProduct = val;
      }
    },
    methods: {
      variantSelection: function(variant) {
        this.currentVariants.forEach(x => {
          x.isSelected = false;
        });
        variant.isSelected = true;

        if (variant.type == ProductTypes.Group) {
          this.variantDataSet.push(this.currentVariants);
          this.currentVariants = variant.children;
        } else {
          let obj = {
            product: this.preSelectedProduct,
            sizeId: variant.sizeId
          }
          this.$store.dispatch("selfservice/productSelectionCompleted", obj);
        }
      },
      backVariantSelection: function() {
        this.currentVariants = this.variantDataSet.pop();
      },
      closeVariantSelection: function() {
        this.selectedProduct = null;
        this.$emit("closeProductSelection");
      },
      productSelectionCompleted: function() {
        this.$emit("productSelectionCompleted", this.preSelectedProduct);
      }

    }
  };
</script>
<style>
#variant-first-selection .vs-popup .vs-popup--content {
    margin: 0 !important;
    padding: 0 !important;
    width: 100% !important;
  }
  #variant-first-selection .vs-popup {
    border-radius: 2rem!important
  }

  #variant-first-selection .vs-popup .vs-popup--content .vs-row .vs-col button i {
    font-weight: 600 !important;
  }

  #variant-first-selection .vs-popup .vs-popup--header {
    display: none !important;
  }
  </style>
